import React from 'react';
import PropTypes from 'prop-types';
import { SheetTrigger } from 'components/ui/sheet';
import { Button } from 'components/ui/button';
import { ChevronRight } from 'lucide-react';

const PilgrimDetailsTrigger = ({ pilgrimData, onSelect }) => (
  <SheetTrigger asChild>
    <Button
      type="button"
      variant="link"
      className="mt-1 h-auto min-h-6 justify-start gap-0.5 rounded-sm p-0 text-[13px] text-hajj-primary hover:text-hajj-primary/80 focus-visible:ring-hajj-primary"
      aria-label={(
        'Voir le dossier de ' +
        [pilgrimData?.pilgrim?.first_name, pilgrimData?.pilgrim?.last_name].filter(Boolean).join(' ')
      ).trim()}
      onClick={() => onSelect(pilgrimData)}
    >
      Voir le dossier <ChevronRight className="size-3.5" aria-hidden="true" />
    </Button>
  </SheetTrigger>
);

PilgrimDetailsTrigger.propTypes = {
  pilgrimData: PropTypes.shape({}).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PilgrimDetailsTrigger;
